"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualizedTable = exports.RowCell = exports.FooterCell = exports.ColumnCell = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_table_1 = require("react-table");
var react_virtual_1 = require("react-virtual");
var Cell_1 = require("../../atoms/Cell");
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
exports.ColumnCell = react_2.default.memo(function (_a) {
    var column = _a.column;
    var props = (0, react_2.useMemo)(function () { return column.getHeaderProps(); }, [column]);
    var content = (0, react_2.useMemo)(function () { return column.render('Header'); }, [column]);
    return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "head", role: "columnheader" }, props, { children: content })));
});
exports.FooterCell = react_2.default.memo(function (_a) {
    var column = _a.column, children = _a.children;
    var props = (0, react_2.useMemo)(function () { return column.getFooterProps(); }, [column]);
    return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "head", role: "rowgroup" }, props, { children: children })));
});
exports.RowCell = react_2.default.memo(function (_a) {
    var cell = _a.cell, className = _a.className, rest = __rest(_a, ["cell", "className"]);
    var props = (0, react_2.useMemo)(function () { return cell.getCellProps(); }, [cell]);
    var content = (0, react_2.useMemo)(function () { return cell.render('Cell'); }, [cell]);
    return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "body" }, props, rest, { className: className }, { children: content })));
});
var VirtualizedTableInner = react_2.default.memo(function (_a) {
    var data = _a.data, columns = _a.columns, emptyDataText = _a.emptyDataText, minTableWidth = _a.minTableWidth, onRowClick = _a.onRowClick, _b = _a.variant, variant = _b === void 0 ? 'fill' : _b, _c = _a.itemSize, itemSize = _c === void 0 ? 66 : _c, hasNextPage = _a.hasNextPage, isNextPageLoading = _a.isNextPageLoading, _d = _a.loadNextPage, loadNextPage = _d === void 0 ? function () { } : _d, infinite = _a.infinite, loading = _a.loading, hasFooter = _a.hasFooter, _e = _a.clickable, clickable = _e === void 0 ? false : _e, _f = _a.threshold, threshold = _f === void 0 ? 5 : _f, _g = _a.loadMoreIndicatorSize, loadMoreIndicatorSize = _g === void 0 ? 35 : _g, _h = _a.headerHeight, headerHeight = _h === void 0 ? 43 : _h, isEditing = _a.isEditing, selectable = _a.selectable, _j = _a.listPadding, listPadding = _j === void 0 ? '285px' : _j, rest = __rest(_a, ["data", "columns", "emptyDataText", "minTableWidth", "onRowClick", "variant", "itemSize", "hasNextPage", "isNextPageLoading", "loadNextPage", "infinite", "loading", "hasFooter", "clickable", "threshold", "loadMoreIndicatorSize", "headerHeight", "isEditing", "selectable", "listPadding"]);
    var tableData = (0, react_2.useMemo)(function () { return data; }, [data]);
    var hasData = tableData && tableData.length > 0;
    var showData = hasData;
    var isEmpty = !hasData && !loading;
    var isFirstLoad = !hasData && loading;
    var parentRef = (0, react_2.useRef)();
    var rowVirtualizer = (0, react_virtual_1.useVirtual)({
        size: hasNextPage ? tableData.length + 1 : tableData.length,
        parentRef: parentRef,
        estimateSize: (0, react_2.useCallback)(function () { return itemSize; }, [itemSize]),
        overscan: threshold,
    });
    (0, react_2.useEffect)(function () {
        var lastItem = rowVirtualizer.virtualItems[rowVirtualizer.virtualItems.length - 1];
        if (lastItem &&
            lastItem.index >= tableData.length - 1 &&
            hasNextPage &&
            !isNextPageLoading &&
            !loading &&
            infinite) {
            loadNextPage();
        }
    }, [
        hasNextPage,
        infinite,
        isNextPageLoading,
        loadNextPage,
        loading,
        rowVirtualizer.virtualItems,
        tableData.length,
    ]);
    var memoizedColumns = (0, react_2.useMemo)(function () { return columns; }, [columns]);
    var _k = (0, react_table_1.useTable)(__assign({ columns: memoizedColumns, data: tableData, 
        // @ts-ignore-next-line
        autoResetPage: false, autoResetExpanded: false, autoResetGroupBy: false, autoResetSelectedRows: false, autoResetSortBy: false, autoResetFilters: false, autoResetRowState: false }, rest), react_table_1.useFlexLayout, react_table_1.useRowSelect, function (hooks) {
        if (selectable) {
            hooks.visibleColumns.push(function (visibleColumns) { return __spreadArray([
                // Let's make a column for selection
                {
                    id: 'selection',
                    width: '64px',
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    // @ts-ignore
                    Header: react_2.default.memo(function (_a) {
                        var getToggleAllRowsSelectedProps = _a.getToggleAllRowsSelectedProps;
                        var _b = getToggleAllRowsSelectedProps(), indeterminate = _b.indeterminate, checked = _b.checked, props = __rest(_b, ["indeterminate", "checked"]);
                        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(atoms_1.Checkbox, __assign({}, props, { id: "RowSelectAllCheckbox", indeterminate: indeterminate, checked: checked || indeterminate })) }));
                    }),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: react_2.default.memo(function (_a) {
                        var row = _a.row;
                        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(atoms_1.Checkbox, __assign({ id: "RowSelectCheckbox__".concat(row.id) }, row.getToggleRowSelectedProps())) }));
                    }),
                }
            ], visibleColumns, true); });
        }
    }), getTableBodyProps = _k.getTableBodyProps, headerGroups = _k.headerGroups, prepareRow = _k.prepareRow, rows = _k.rows;
    var classes = (0, styles_1.default)(__assign({ hasData: hasData, loading: isFirstLoad, clickable: clickable, variant: variant, itemSize: itemSize, loadMoreIndicatorSize: loadMoreIndicatorSize, minTableWidth: minTableWidth, headerHeight: headerHeight, infinite: infinite, isEditing: isEditing, hasFooter: hasFooter }, rest));
    var Headers = react_2.default.memo(function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "rowgroup", className: classes.header }, { children: headerGroups.map(function (headerGroup) {
            var _a = headerGroup.getHeaderGroupProps(), className = _a.className, key = _a.key;
            return ((0, react_1.createElement)("div", __assign({ role: "row", className: [classes.row, className].join(' ') }, headerGroup.getHeaderGroupProps(), { key: key }), headerGroup.headers.map(function (column) {
                var columnKey = column.getHeaderProps().key;
                return (0, jsx_runtime_1.jsx)(exports.ColumnCell, { column: column }, columnKey);
            })));
        }) }))); });
    var LoadingRow = react_2.default.memo(function (_a) {
        var props = __rest(_a, []);
        return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "row", className: classes.loadingMoreRow, "data-testid": "loading-row" }, props, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "body" }, { children: (0, jsx_runtime_1.jsx)(atoms_1.LoadingIndicator, { loading: isNextPageLoading, size: "".concat(loadMoreIndicatorSize, "px") }) })) })));
    });
    var TableRow = react_2.default.memo(function (_a) {
        var _b;
        var vRow = _a.vRow;
        var isLoaderRow = infinite && vRow.index > tableData.length - 1;
        if (isLoaderRow)
            return ((0, jsx_runtime_1.jsx)(LoadingRow, { style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    transform: "translateY(".concat(vRow.start, "px)"),
                } }));
        var row = rows[vRow.index];
        prepareRow(row);
        var handleRowClick = function () {
            if (clickable && onRowClick) {
                onRowClick(row);
            }
        };
        var _c = row.getRowProps(), style = _c.style, className = _c.className, rowProps = __rest(_c, ["style", "className"]);
        var rowClasses = [classes.row, classes.clickableRow, classes.editableRow, className];
        var disabledRow = ((_b = row === null || row === void 0 ? void 0 : row.original) === null || _b === void 0 ? void 0 : _b.disabled) || false;
        if (disabledRow) {
            rowClasses.push(classes.disabledRow);
        }
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        (0, jsx_runtime_1.jsx)("div", __assign({ role: "row", tabIndex: vRow.index, onClick: handleRowClick, className: __spreadArray([], rowClasses, true).join(' '), id: "Row".concat(vRow.index, "Button"), style: __assign(__assign({}, style), { position: 'absolute', top: 0, left: 0, width: '100%', transform: "translateY(".concat(vRow.start, "px)") }), ref: vRow.measureRef }, rowProps, { children: row === null || row === void 0 ? void 0 : row.cells.map(function (cell, i) {
                var _a, _b, _c;
                var cellKey = cell.getCellProps().key;
                return ((0, jsx_runtime_1.jsx)(exports.RowCell, { cell: cell, "data-testcolumn": (_b = (_a = row === null || row === void 0 ? void 0 : row.allCells[i]) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.id, "data-testid": "Column".concat((_c = cell === null || cell === void 0 ? void 0 : cell.column) === null || _c === void 0 ? void 0 : _c.id, "Cell").concat(i), className: disabledRow ? classes.disabledCell : '' }, cellKey));
            }) })));
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Headers, {}), isFirstLoad && ((0, jsx_runtime_1.jsx)("div", __assign({}, getTableBodyProps(), { children: (0, jsx_runtime_1.jsx)("div", __assign({ role: "row", className: classes.loadingMoreRow }, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "body" }, { children: (0, jsx_runtime_1.jsx)(atoms_1.LoadingIndicator, { loading: true }) })) })) }))), isEmpty && ((0, jsx_runtime_1.jsx)("div", __assign({}, getTableBodyProps(), { children: (0, jsx_runtime_1.jsx)("div", __assign({ role: "row" }, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ component: "span", variant: "body" }, { children: emptyDataText })) })) }))), showData && ((0, jsx_runtime_1.jsx)("div", __assign({}, getTableBodyProps(), { className: classes.tableBody }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.list, ref: parentRef, style: {
                        paddingBottom: tableData.length > 8 ? listPadding : '0px',
                    } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                            height: "".concat(rowVirtualizer.totalSize, "px"),
                            position: 'relative',
                        } }, { children: rowVirtualizer.virtualItems.map(function (vRow) { return ((0, jsx_runtime_1.jsx)(TableRow, { vRow: vRow }, vRow.index)); }) })) })) })))] }));
});
exports.VirtualizedTable = react_2.default.memo(function (_a) {
    var _b = _a.footer, footer = _b === void 0 ? [] : _b, virtualizedTableProps = __rest(_a, ["footer"]);
    var tableData = (0, react_2.useMemo)(function () { return virtualizedTableProps.data; }, [virtualizedTableProps.data]);
    var hasData = tableData && tableData.length > 0;
    var isFirstLoad = !hasData && virtualizedTableProps.loading;
    var _c = (0, react_table_1.useTable)(__assign({ 
        // @ts-ignore-next-line
        autoResetPage: false, autoResetExpanded: false, autoResetGroupBy: false, autoResetSelectedRows: false, autoResetSortBy: false, autoResetFilters: false, autoResetRowState: false }, virtualizedTableProps), react_table_1.useFlexLayout, react_table_1.useRowSelect), getTableProps = _c.getTableProps, footerGroups = _c.footerGroups;
    var classes = (0, styles_1.default)(__assign(__assign({}, virtualizedTableProps), { hasData: hasData, loading: isFirstLoad, hasFooter: !!footer.length, headerHeight: virtualizedTableProps.headerHeight || 43 }));
    var Footer = react_2.default.memo(function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "rowgroup", className: classes.footer }, { children: footerGroups.map(function (footerGroup) {
            var _a = footerGroup.getFooterGroupProps(), className = _a.className, key = _a.key;
            return ((0, react_1.createElement)("div", __assign({ role: "row", className: [classes.row, className].join(' ') }, footerGroup.getFooterGroupProps(), { key: key }), footerGroup.headers.map(function (column, index) {
                var columnKey = column.getFooterProps().key;
                return ((0, jsx_runtime_1.jsx)(exports.FooterCell, __assign({ column: column }, { children: footer[index] }), columnKey));
            })));
        }) }))); });
    var paperClasses = (0, react_2.useMemo)(function () {
        var applyClasses = [classes.paper];
        if (virtualizedTableProps.isEditing && virtualizedTableProps.type === 'workbook') {
            applyClasses.push(classes.tableEdit);
        }
        return applyClasses.join(' ');
    }, [
        classes.paper,
        classes.tableEdit,
        virtualizedTableProps.isEditing,
        virtualizedTableProps.type,
    ]);
    return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ px: "3px", py: "5px" }, { children: (0, jsx_runtime_1.jsx)(core_1.Paper, __assign({ className: paperClasses, elevation: 2, "data-testid": "paper-container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.table }, getTableProps(), { children: [(0, jsx_runtime_1.jsx)(VirtualizedTableInner, __assign({}, virtualizedTableProps, { hasFooter: Boolean(footer.length) })), !!footer.length && (0, jsx_runtime_1.jsx)(Footer, {})] })) })) })));
});
